export default {
    namespaced: true,
    state: () => ({
        currentSurah: JSON.parse(localStorage.getItem('currentSurah')) || null,
        isPlaying: false,
        duration: 0,
        currentTime: 0,
        audioUrl: '',
        queue: []
    }),
    mutations: {
        SET_SURAH(state, surah) {
            state.currentSurah = surah;
            localStorage.setItem('currentSurah', JSON.stringify(surah));
        },
        SET_PLAYING(state, status) {
            state.isPlaying = status;
        },
        SET_DURATION(state, duration) {
            state.duration = duration;
        },
        SET_CURRENT_TIME(state, time) {
            state.currentTime = time;
        },
        SET_QUEUE(state, queue) {
            state.queue = queue;
        }
    },
    actions: {
        playSurah({ commit, state }, { surah, queue = [] }) {
            commit('SET_SURAH', surah);
            if (queue.length > 0) commit('SET_QUEUE', queue);
            commit('SET_PLAYING', true);
        },
        togglePlay({ commit, state }) {
            commit('SET_PLAYING', !state.isPlaying);
        },
        updateProgress({ commit }, { currentTime, duration }) {
            commit('SET_CURRENT_TIME', currentTime);
            if (duration) commit('SET_DURATION', duration);
        },
        stop({ commit }) {
            commit('SET_PLAYING', false);
        }
    },
    getters: {
        currentSurah: state => state.currentSurah,
        isPlaying: state => state.isPlaying,
        progress: state => (state.currentTime / state.duration) * 100 || 0,
        queue: state => state.queue
    }
}
